import React, { useEffect, useState } from 'react';
import classes from "./Profile.module.css";
import Header from '../components/Header';
import BottomNavbar from '../components/BottomNavbar';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import RewardsAnimation from "../animations/rewards.json";
import { getProfile, unsubscribeAPI } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { FaChevronRight } from "react-icons/fa";
import { removeUserToken } from '../store/slices/userTokenSlice';
import MediumLoader from '../components/Loaders/MediumLoader';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import UnSubModal from '../components/UnSubModal';
import UserAccount from '../components/UserAccount';
import SubLayout from '../components/SubLayout';

const Profile = () => {
    const navigate = useNavigate();
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [modal,setModal]=useState(false);
    const [unsubLoading,setUnsubLoading]=useState(false);

    const { t } = useTranslation();

    const [userProfile, setUserProfile] = useState(null);

    const unsubscribeUser=async()=>{
        try {
            setUnsubLoading(true);
            const response=await unsubscribeAPI(userProfile?.msisdn);
            setUnsubLoading(false);

            console.log(response,'response...');
            logoutHandler();
            toast.success(t("95"));
        } catch (error) {
            setUnsubLoading(false);

            toast.error(t("86"));
        }
    }

    const fetchUserProfile = async () => {
        try {
            setLoading(true);
            const response = await getProfile(userToken);
            setUserProfile(response?.data?.result);
            setLoading(false);
        } catch (error) {
            setLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        fetchUserProfile();
    }, []);

    const logoutHandler = () => {
        dispatch(removeUserToken());
        navigate("/");
    }
    return (
        <>
            <Header />

            <UserAccount userProfile={userProfile} />

            {/* <div className={classes.container}>
                {loading ? <MediumLoader /> :
                    <div className={classes.profile_section}>
                        <div className={classes.profile_sub_section}>
                            <div className={classes.profile_avatar}>
                                <img src={userProfile?.image ?? "/assets/images/dummy.png"} alt={userProfile?.name ?? t("1")} className={classes.avatar_image} />
                            </div>
                            <div className={classes.profile_details}>
                                <p className={classes.profile_text}>{userProfile?.name ?? t("1")}</p>
                                <p className={classes.profile_text}>{userProfile?.msisdn}</p>
                            </div>
                        </div>

                        <div className={classes.user_points_container}>
                            <div className={classes.rewards_animation}>
                                <Lottie animationData={RewardsAnimation} loop autoPlay className={classes.animation} />
                            </div>
                            <p className={classes.points}>{userProfile?.total_points} {t("2")}</p>
                        </div>

                    </div>
                }

            </div> */}
            <SubLayout style={{padding:"20px 0"}}>

            {/* <div className={`${classes.container} ${classes.no_padding}`}> */}
                <div className={classes.menu_item_container} onClick={() => navigate("/history")}>
                    <div className={classes.menu_item}>
                        <img src='/assets/images/refresh.png' alt="history" className={classes.menu_item_image} />
                        <p className={classes.menu_item_name}>{t("19")}</p>
                    </div>

                    <div className={classes.arrow_container}>
                        <FaChevronRight className={classes.right_icon} />
                    </div>
                </div>

                <div className={classes.menu_item_container} onClick={() => navigate("/edit-profile")}>
                    <div className={classes.menu_item}>
                        <img src='/assets/images/edit.png' alt="edit profile" className={classes.menu_item_image} />
                        <p className={classes.menu_item_name}>{t("20")}</p>
                    </div>

                    <div className={classes.arrow_container}>
                        <FaChevronRight className={classes.right_icon} />
                    </div>
                </div>

                <div className={classes.menu_item_container} onClick={() => navigate("/language")}>
                    <div className={classes.menu_item}>
                        <img src='/assets/images/language.png' alt="Language" className={classes.menu_item_image} />
                        <p className={classes.menu_item_name}>{t("21")}</p>
                    </div>

                    <div className={classes.arrow_container}>
                        <FaChevronRight className={classes.right_icon} />
                    </div>
                </div>

                <div className={classes.menu_item_container} onClick={() => navigate("/policy")}>
                    <div className={classes.menu_item}>
                        <img src='/assets/images/note.png' alt="Rules & Policies" className={classes.menu_item_image} />
                        <p className={classes.menu_item_name}>{t("22")}</p>
                    </div>

                    <div className={classes.arrow_container}>
                        <FaChevronRight className={classes.right_icon} />
                    </div>
                </div>

                <div className={classes.menu_item_container} onClick={() => navigate("/contact-us")}>
                    <div className={classes.menu_item}>
                        <img src='/assets/images/support.png' alt="Contact Us" className={classes.menu_item_image} />
                        <p className={classes.menu_item_name}>{t("23")}</p>
                    </div>

                    <div className={classes.arrow_container}>
                        <FaChevronRight className={classes.right_icon} />
                    </div>
                </div>

                <div className={classes.menu_item_container} onClick={() => setModal(true)}>
                    <div className={classes.menu_item}>
                        <img src='/assets/images/unsubscribe.png' alt="Unsubscribe" className={classes.menu_item_image} />
                        <p className={classes.menu_item_name}>{t("82")}</p>
                    </div>

                    <div className={classes.arrow_container}>
                        <FaChevronRight className={classes.right_icon} />
                    </div>
                </div>

                <div className={classes.menu_item_container} onClick={() => logoutHandler()}>
                    <div className={classes.menu_item}>
                        <img src='/assets/images/logout.png' alt="Logout" className={classes.menu_item_image} />
                        <p className={classes.menu_item_name}>{t("24")}</p>
                    </div>

                    <div className={classes.arrow_container}>
                        <FaChevronRight className={classes.right_icon} />
                    </div>
                </div>
            </SubLayout>

            {/* </div> */}
            <BottomNavbar active={4} />

            {modal && <UnSubModal setModal={setModal} unsubscribeUser={unsubscribeUser} unsubLoading={unsubLoading}/>}
        </>
    )
}

export default Profile